<form [formGroup]="specInkomenBox2FormGroup">
    <div formGroupName="specificatieBox2">
        <div formGroupName="opbouw">
            <div class="row">
                <div class="col col-1">
                    Reguliere voordelen aanmerkelijk belang
                </div>
                <div class="col-2">
                    <snelstart-ui-number-form-control
                            [decimals]="0"
                            align="right"
                            class="custom-input-150"
                            formControlName="reguliereVoordelen"
                            id="reguliereVoordelen"
                            prefix="€"
                    ></snelstart-ui-number-form-control>
                </div>
                <div class="col-3"></div>
                <div class="col-4"></div>
            </div>
            <div class="row">
                <div class="col col-1">
                    Af: Aftrekbare kosten
                </div>
                <div class="col-2">
                    <snelstart-ui-number-form-control
                            [decimals]="0"
                            align="right"
                            class="custom-input-150"
                            formControlName="aftrekbareKosten"
                            id="aftrekbareKosten"
                            prefix="€ -"
                    ></snelstart-ui-number-form-control>
                </div>
                <div class="col-3"></div>
                <div class="col-4"></div>
            </div>
            <div class="row">
                <div class="col col-1">
                    Fictieve reguliere voordelen aanmerkelijk belang
                </div>
                <div class="col-2">
                    <snelstart-ui-number-form-control
                            [decimals]="0"
                            align="right"
                            class="custom-input-150"
                            formControlName="fictieveReguliereVoordelen"
                            id="fictieveReguliereVoordelen"
                            prefix="€"
                    ></snelstart-ui-number-form-control>
                </div>
                <div class="col-3"></div>
                <div class="col-4"></div>
            </div>
            <div class="row">
                <div class="col col-1">
                    Vervreemdingsvoordelen aanmerkelijk belang
                </div>
                <div class="col-2">
                    <snelstart-ui-number-form-control
                            [decimals]="0"
                            align="right"
                            class="custom-input-150"
                            formControlName="vervreemdingsVoordelen"
                            id="vervreemdingsVoordelen"
                            prefix="€"
                    ></snelstart-ui-number-form-control>
                </div>
                <div class="col-3"></div>
                <div class="col-4"></div>
            </div>
            <div class="row">
                <div class="col col-1">
                    Af: Verkrijgingsprijs
                </div>
                <div class="col-2">
                    <snelstart-ui-number-form-control
                            [decimals]="0"
                            align="right"
                            class="custom-input-150"
                            formControlName="verkrijgingsPrijs"
                            id="verkrijgingsPrijs"
                            prefix="€ -"
                    ></snelstart-ui-number-form-control>
                </div>
                <div class="col-3"></div>
                <div class="col-4"></div>
            </div>
        </div>
    </div>
</form>

<form [formGroup]="specInkomenBox2FormGroup">
    <div formGroupName="specificatieInkomenBox2">
        <div formGroupName="opbouw">
            <div class="row">
                <div class="col col-1">
                    <p><b>Inkomen uit aanmerkelijk belang</b></p>
                </div>
                <div class="col-2"></div>
                <div class="col-3">
                    <snelstart-ui-number-form-control
                            [decimals]="0"
                            align="right"
                            class="custom-input-150"
                            formControlName="saldoAanmerkelijkBelang"
                            id="saldoAanmerkelijkBelang"
                            prefix="€"
                    ></snelstart-ui-number-form-control>
                </div>
                <div class="col-4"></div>
            </div>
        </div>
    </div>
</form>

<div class="space20"></div>

<div *ngIf="berekening.partnerBerekening">

    <form [formGroup]="berekeningFormGroup">
        <div formGroupName="box2">
            <div formGroupName="opbouwInkomen">
                <div *ngIf="berekening.partnerBerekening">
                    <div class="row">
                        <div class="col col-1">
                            <p>Aandeel voor {{ this.dataService.naamAangever }}</p>
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="inkomenUitAanmerkelijkBelang"
                                    id="inkomenUitAanmerkelijkBelang"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                    </div>
                </div>
                <div *ngIf="berekening.box2?.opbouwInkomen?.verrekendVerlies">
                    <div class="row">
                        <div class="col col-1">
                            <p>Af: Verrekend verlies</p>
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="verrekendVerlies"
                                    id="verrekendVerlies"
                                    prefix="€ -"
                            ></snelstart-ui-number-form-control>
                        </div>
                    </div>
                </div>
                <div *ngIf="berekening.box2?.opbouwInkomen?.verrekendVerlies">
                    <div class="row">
                        <div class="col col-1">
                            <p>Inkomen uit aanmerkelijk belang (box 2) voor {{ this.dataService.naamAangever }}</p>
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="inkomen"
                                    id="inkomen"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>

    <form [formGroup]="berekeningPartnerFormGroup">
            <div formGroupName="partnerBerekening">
                <div formGroupName="box2">
                    <div formGroupName="opbouwInkomen">
                        <div *ngIf="berekening.partnerBerekening">
                            <div class="row pt-1">
                                <div class="col col-1">
                                    <p>Aandeel voor {{ this.dataService.naamPartner }}</p>
                                </div>
                                <div class="col-2">
                                    <snelstart-ui-number-form-control
                                            [decimals]="0"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="inkomenUitAanmerkelijkBelang"
                                            id="inkomenUitAanmerkelijkBelangPartner"
                                            prefix="€"
                                    ></snelstart-ui-number-form-control>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="berekening.partnerBerekening?.box2?.opbouwInkomen?.verrekendVerlies">
                                <div class="row">
                                    <div class="col col-1">
                                        <p>Af: Verrekend verlies</p>
                                    </div>
                                    <div class="col-2">
                                        <snelstart-ui-number-form-control
                                                [decimals]="0"
                                                align="right"
                                                align="right"
                                                class="custom-input-150"
                                                formControlName="verrekendVerlies"
                                                id="verrekendVerliesPartner"
                                                prefix="€ -"
                                        ></snelstart-ui-number-form-control>
                                    </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="berekening.partnerBerekening?.box2?.opbouwInkomen?.verrekendVerlies">
                        <div class="row">
                            <div class="col col-1">
                                <p>Inkomen uit aanmerkelijk belang (box 2) voor {{ this.dataService.naamPartner }}</p>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-number-form-control
                                        [decimals]="0"
                                        align="right"
                                        class="custom-input-150"
                                        formControlName="inkomen"
                                        id="inkomenPartner"
                                        prefix="€"
                                ></snelstart-ui-number-form-control>
                            </div>
                        </div>
                </div>
            </div>
        </div>
    </form>

</div>
